import React from 'react'
import { useDispatch } from 'react-redux'

import { Button } from 'components/Forms'
import BaseModal from 'components/Modals/BaseModal'
import { closeModal } from 'store/actions/modals'
import { closePunchTerminal } from 'store/actions/punchTerminal'
import { useTranslation } from 'react-i18next'

const PunchTerminalShutdown = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <BaseModal hideButtons>
      <h4>{t(`punch.CLOSE_PUNCH_TERMINAL.TITLE`)}</h4>
      <p>{t(`punch.CLOSE_PUNCH_TERMINAL.SUMMARY`)}</p>
      <div className="mt-3">
        <Button
          className="btn btn-primary mr-2"
          text={t(`punch.CLOSE_PUNCH_TERMINAL.CONFIRM`)}
          onClick={() => {
            dispatch(closePunchTerminal())
            dispatch(closeModal())
          }}
        />

        <Button className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())}>
          {t(`punch.CLOSE_PUNCH_TERMINAL.CANCEL`)}
        </Button>
      </div>
    </BaseModal>
  )
}

export default PunchTerminalShutdown
